import { HeaderNavLink } from './header-menu';

/**
 * Account navigation: destinations that belong to the signed-in user rather than to the site's main sections.
 * Rendered inside the profile menu (desktop) and in the account block at the bottom of the mobile drawer, so it is
 * never shown to guests. Kept apart from `HEADER_NAV` on purpose: primary navigation and account navigation are
 * different things, and mixing them would spend header width on links most visits do not need.
 *
 * "Profile" and "Log out" are fixed actions of the profile menu itself and are not listed here; "My Orders" is
 * intentionally hidden (05e530b0), so restore it by adding it here and it will appear in both places.
 */
export const HEADER_ACCOUNT_NAV: readonly HeaderNavLink[] = [
  { id: 'vehicles', labelKey: 'MENUS.VEHICLES', icon: 'pi pi-car', link: '/vehicles' }
];

/** The profile page. It is part of the profile menu, not of `HEADER_ACCOUNT_NAV`. */
export const PROFILE_ROUTE = '/user-profile';
